export default __webpack_public_path__ + "static/media/img-api-logo-prealpha.bd9ea673.png";